<script>
	export let data;
	export let { issues } = data;
	// console.log(issues);
</script>

<div class="px-6 py-8 lg:py-20 lg:px-8">
	<div class="max-w-6xl mx-auto text-base leading-7">
		<h1 class="text-2xl font-bold">List of issues</h1>
		<p class="text-gray-600">List of all issues publised in DCPapers</p>

		<ul role="list" class="divide-y divide-gray-100">
			{#each issues as issue (issue.id)}
				<li class="flex items-center justify-between py-5 gap-x-6">
					<div class="min-w-0">
						<div class="flex items-start gap-x-3">
							<p class="text-sm font-semibold leading-6 text-blue-900">
								<a href="/issue/{issue.id}">{issue.title}</a>
							</p>
							<!-- Optionally display a status badge here -->
						</div>
						<div class="flex items-center mt-1 text-xs leading-5 text-gray-500 gap-x-2">
							<p class="whitespace-nowrap">Year: {issue.year}</p>
							<!-- Other issue metadata like creation date, authors, etc. -->
						</div>
					</div>
					<div class="flex items-center flex-none gap-x-4">
						<a
							href="/issue/{issue.id}"
							class="rounded-md bg-white px-2.5 py-1.5 text-sm text-blue-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
							>View Issue</a
						>
						<!-- Add other buttons or dropdowns as needed -->
					</div>
				</li>
			{/each}
		</ul>
	</div>
</div>
